export default {
  labels: {
    email: 'Email ID',
  },
  placeholders: {
    email: 'Enter your Email Id',
  },
  buttons: {
    sendEmail: 'Send Email',
    backToLogin: 'Back to Login',
    save: 'Save',
  },
  title: {
    forgotPassword: 'Forgot Password',
  },
};
